import React from 'react';
import PropTypes from 'prop-types';
import css from './ContactSection.scss';
import Title from '../../common/Title';
import ContactMoreOptions from "./ContactMoreOptions";
import { formatPhoneNumber } from "utils/formatter";

export default class ContactSection extends React.Component {

  get email() {
    const { email } = this.props;
    return email ? <a href={`mailto:${email}`}>Send an email</a> : null;
  }

  get phone() {
    const { phoneNumber } = this.props;
    return phoneNumber ? <a href={`tel:${phoneNumber}`}>Call {formatPhoneNumber(phoneNumber)}</a> : null;
  }

  get moreOptions() {
    const { videoPhone, mobilePhone } = this.props;
    if(!(videoPhone || mobilePhone)) return null;
    return <ContactMoreOptions mobilePhone={formatPhoneNumber(mobilePhone)} videoPhone={videoPhone}/>
  }

  render() {
    return (
      <div>
        <Title text="Contact" />
        <div className={css['contact-container']}>
          {this.email}
          {this.phone}
          {this.moreOptions}
        </div>
      </div>
    );
  }
}

ContactSection.propTypes = {
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  mobilePhone: PropTypes.string,
  videoPhone: PropTypes.string
};
